import { render, staticRenderFns } from "./SendMedPrescriptions.vue?vue&type=template&id=79dc7b43&scoped=true"
import script from "./SendMedPrescriptions.vue?vue&type=script&lang=js"
export * from "./SendMedPrescriptions.vue?vue&type=script&lang=js"
import style0 from "./SendMedPrescriptions.vue?vue&type=style&index=0&id=79dc7b43&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc7b43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79dc7b43')) {
      api.createRecord('79dc7b43', component.options)
    } else {
      api.reload('79dc7b43', component.options)
    }
    module.hot.accept("./SendMedPrescriptions.vue?vue&type=template&id=79dc7b43&scoped=true", function () {
      api.rerender('79dc7b43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/takeChmedicine/SendMedPrescriptions.vue"
export default component.exports